<template>
  <div class="row">
    <div class="col-12">
        <template v-if="hasParish">
            <div
                v-for="(target, index) in parishes"
                :key="index"
                class="form-check city-form-check"
            >
                <input
                :id="'checkTarget'+target.dicofre"
                v-model="mutableValue"
                v-validate="''"
                class="form-check-input"
                type="checkbox"
                :disabled="readonlyFormItem"
                :value="target"
                :name="'parishes[]'"
                >
                <label class="form-check-label text-nowrap" :for="'checkTarget'+target.dicofre">
                {{ target.name }}
                </label>
            </div>
        </template>
        <template v-else>
            <div class="alert alert-info text-center" role="alert">
                {{ $t(`${pageID}.msg.no-parish`) }}
            </div>
        </template>
    </div>
  </div>
</template>


<script>
import mixin from '../../../../../mixin';

export default {
    mixins: [mixin],
    inject: {
        parentValidator: 'parentValidator',
    },
    props: {
        vScope: {
            type: String,
            default: 'form'
        },
        value: {
            type: Array,
            default: () => { return [] },
        },
        propPageID: {
            type: String,
            required: true,
        },
        parishes: {
            type: Array,
            default: () => { return []; },
        },
    },
    data() {
        return {
            autoloadItem: false,
            mutableValue: []
        }
    },
    created: function() {
        this.pageID = this.propPageID;
        this.$validator = this.parentValidator;
        this.copyValue(this.value);
    },
    computed: {
        hasParish() {
            return !!this.parishes.length;
        }
    },
    methods: {
        copyValue (value) {
            this.mutableValue = value;
        },
    },
    watch: {
        value: function(newValue) {
            this.copyValue(newValue);
        },
        mutableValue: function() {
            this.$emit('input', this.mutableValue);
        }
    },
}
</script>